
import { useQuery } from "@tanstack/react-query";
import { fetchProjectById, fetchProjectMedia } from "@/services/api";

export const useProjectDetail = (projectId: string) => {
  const {
    data: project,
    isLoading: isProjectLoading,
    isError: isProjectError,
    error: projectError
  } = useQuery({
    queryKey: ["project", projectId],
    queryFn: () => fetchProjectById(projectId),
    enabled: !!projectId,
    retry: 1, // Limit retries to avoid multiple failed attempts
    staleTime: 5 * 60 * 1000, // Cache project data for 5 minutes
  });

  const {
    data: projectMedia = [],
    isLoading: isMediaLoading,
    isError: isMediaError
  } = useQuery({
    queryKey: ["project-media", projectId],
    queryFn: () => fetchProjectMedia(projectId),
    enabled: !!projectId && !isProjectLoading && !isProjectError,
    staleTime: 5 * 60 * 1000, // Cache media data for 5 minutes
  });

  return {
    project,
    projectMedia,
    isLoading: isProjectLoading || isMediaLoading,
    isError: isProjectError || isMediaError,
    error: projectError,
  };
};
